import { TrackingNotice } from "../../../../customNotice/botNotice/trackingNotice";
export class LoginExtension {
    constructor(chatScreen) {
        this.name = 'login';
        this.lazyLoadLoginOverlay = () => {
            return new Promise((resolve, reject) => {
                if (this.loginOverlay) {
                    resolve();
                    return;
                }
                import(/* webpackChunkName: "loginOverlay.v4.0.0" */ './loginOverlay').then(({ default: _ }) => {
                    this.loginOverlay = new _(this.chatScreen.uic.widget);
                    this.loginOverlay.bootstrap(this.loginContainer, () => {
                        this.loginOverlay.subscribeToCloseOverlay(() => {
                            this.deactivate();
                        });
                        this.observeChange();
                        resolve();
                    });
                    return;
                })
                    .catch((error) => 'An error occurred while loading the component');
            });
        };
        this.active = false;
        this.chatScreen = chatScreen;
        this.loginContainer = $('<div></div>');
        chatScreen.elements['completeChatwindow'].append(this.loginContainer);
        this.loginContainer.hide();
        this.chatScreen.uic.widget.subscribeToRestoreEvent(() => {
            this.sendLoginNotice();
        });
    }
    activate(options) {
        this.active = true;
        this.chatScreen.uic.widget.sendCustomNotice(new TrackingNotice("chat", "Login_overlay_show ", "Login_overlay_show"));
        this.chatScreen.loadingAnimation();
        this.lazyLoadLoginOverlay().then(() => {
            this.show();
        });
    }
    deactivate() {
        if (this.active) {
            this.chatScreen.uic.widget.sendCustomNotice(new TrackingNotice("chat", "Login_overlay_close ", "Login_overlay_close"));
            this.active = false;
            this.chatScreen.stopLoadingAnimation();
            this.loginContainer.hide();
            this.chatScreen.showMainInput();
            this.chatScreen.resizeEvent();
        }
    }
    resize() {
        this.chatScreen.resizeEvent();
    }
    show() {
        this.chatScreen.stopLoadingAnimation();
        this.chatScreen.hideMainInput();
        this.loginContainer.show();
        this.chatScreen.resizeEvent();
    }
    sendLoginNotice() {
        if (this.chatScreen.uic.widget.state.loginNotice == true) {
            this.lazyLoadLoginOverlay().then(() => {
                this.loginOverlay.sendLoginNotice();
                this.deactivate();
            });
        }
    }
    observeChange() {
        const targetNode = this.loginContainer.get(0);
        const config = { childList: true, subtree: true };
        const callback = (mutationsList, observer) => {
            this.resize();
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }
}
